export default __webpack_public_path__ + "static/1-0-0-0-301541f4081e04bef653b256e4652c05.jpg";